import React, { useContext } from 'react'
import { QuizQuestionContext, SCREEN_QUIZ_QUESTION } from '../contextAPI'
import { QuizQuestionBase } from '../QuizQuestion'

export const NewBudgetPage: React.FC = () => {
  const { setQuizScreen } = useContext(QuizQuestionContext)
  setQuizScreen(SCREEN_QUIZ_QUESTION.NEW_BUDGET_PAGE)
  return <QuizQuestionBase hardScreen={SCREEN_QUIZ_QUESTION.NEW_BUDGET_PAGE} />
}
